//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'

export default {
  components: {
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData
    }
  },
  watch: {
    tableData: {
      handler (val) {
        console.log(val)
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
  }
}
